export function createPathParamsUrl(
  route: string,
  pathParams: Record<string, string | number | boolean> = {},
) {
  let [url] = route.split('?');

  if (pathParams) {
    const regExp = new RegExp(
      Object.keys(pathParams || {})
        .map((p) => `(:${p})`)
        .join('|'),
      'g',
    );
    url = url.replace(regExp, (x) => {
      return String(pathParams[x.substring(1)]);
    });
  }

  return url;
}
